import axios, { AxiosError } from 'axios';

type ApiError = AxiosError<ApiErrorResponse>;

type ApiErrorResponse = {
  message: string;
};

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL?.replace('v1', 'api'),
  headers: {
    'Content-Type': 'application/json',
    'App-Version': 'Website',
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_API_KEY}`,
  },
});

api.interceptors.response.use(
  response => response,
  (error: ApiError) => {
    if (error.response?.data?.message) {
      return Promise.reject(new Error(error.response.data.message));
    }

    return Promise.reject(
      new Error('An unexpected error occurred. Please try again.')
    );
  }
);

export default api;
export type { ApiError };
